module.exports = __webpack_public_path__ + "img/jj3.a9fd37fa.png";